// src/config/validateEnv.js
const validateEnvironment = () => {
    const requiredVars = [
      'REACT_APP_SUPABASE_URL',
      'REACT_APP_SUPABASE_ANON_KEY'
    ];
  
    const missingVars = requiredVars.filter(
      varName => !process.env[varName]
    );
  
    if (missingVars.length > 0) {
      console.error(
        `Error: Missing required environment variables: ${missingVars.join(', ')}\n` +
        'Make sure you have created a .env file with these variables defined.'
      );
      
      // In development, show a clear error
      if (process.env.NODE_ENV === 'development') {
        alert(`Missing environment variables: ${missingVars.join(', ')}. Check console for details.`);
      }
      
      return false;
    }
  
    return true;
  };
  
  export default validateEnvironment;